<template>
  <div class="sg-find">
    <div class="find-tab">
      <div class="find-tab-item-warp">
        <div
          v-for="item in tabList"
          :key="item.router"
          class="find-tab-item"
          :class="{ active: $route.name === item.router }"
          @click="go(item)">
          {{ item.lable }}
        </div>
      </div>
    </div>
    <router-view />
    <tabbar></tabbar>
    <div style="height: 50px;" />
  </div>
</template>

<script>
import tabbar from '@/components/tabbar'

export default {
  components: {
    tabbar
  },
  data () {
    return {
      tabList: [
        { lable: '女优', router: 'artist' },
        { lable: '排行', router: 'rank' },
        { lable: '分类', router: 'tags' }
      ]
    }
  },
  methods: {
    go (item) {
      if (this.$route.name !== item.router) {
        this.$router.push({ name: item.router })
      }
    }
  }
}
</script>

<style>
.sg-find {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.sg-find .find-tab {
  font-size: 18px;
  color: rgba(188, 189, 193, 1);
  background: #000;
}

.find-tab-item-warp {
  display: flex;
  justify-content: center;
}

.find-tab-item {
  position: relative;
  padding: 10px;
}

.find-tab-item.active {
  font-weight: bold;
  color: #eab87f;
}

.find-tab-item.active::after {
  position: absolute;
  bottom: 2px;
  left: 50%;
  width: 30%;
  height: 3px;
  content: "";
  background: #eab87f;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/views/find/find.vue